import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";
import ADMIN_API_URL from "../../config/AdminApiUrl";

export const getAllAssignee = createAsyncThunk(
  "Assignee/get",
  async (payload, { rejectWithValue, dispatch }) => {
    // dispatch(resetAssigneeList());
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) =>
              value !== null && value !== undefined && value !== "",
          ),
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${API_URL.USER.GET_ASSIGNEE_USER}?${queryString}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${API_URL.USER.GET_ASSIGNEE_USER}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getAllRoles = createAsyncThunk(
  "Role/roles",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.ROLE.GET_ROLE}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getStates = createAsyncThunk(
  "State/getStates",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.STATE.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCountries = createAsyncThunk(
  "Country/getCountries",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_URL.COUNTRY.SLUG);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getActiveProduct = createAsyncThunk(
  "ActiveProduct/get",
  async (payload, { rejectWithValue }) => {
    // try {
    //   const { data } = await axios.get(`${API_URL.USER.GET_RECRUITER_USER}`);
    //   return data;
    // }
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) =>
              value !== null && value !== undefined && value !== "",
          ),
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${API_URL.ITEM.ACTIVE_ITEMS_LOOKUP}?${queryString}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${API_URL.ITEM.ACTIVE_ITEMS_LOOKUP}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getProductGroupLov = createAsyncThunk(
  "ProductGroup/get",
  async (payload, { rejectWithValue }) => {
    // try {
    //   const { data } = await axios.get(`${API_URL.USER.GET_RECRUITER_USER}`);
    //   return data;
    // }
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) =>
              value !== null && value !== undefined && value !== "",
          ),
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${API_URL.ITEM_GROUP.SLUG}?${queryString}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${API_URL.ITEM_GROUP.SLUG}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getManufacturerLov = createAsyncThunk(
  "getManufacturerLOV/get",
  async (payload, { rejectWithValue }) => {
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) =>
              value !== null && value !== undefined && value !== "",
          ),
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${API_URL.MANUFACTURER.LOOKUP}?${queryString}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${API_URL.MANUFACTURER.LOOKUP}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getEmailProviderLov = createAsyncThunk(
  "getEmailProviderLOV/get",
  async (payload, { rejectWithValue }) => {
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) =>
              value !== null && value !== undefined && value !== "",
          ),
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${ADMIN_API_URL.EMAIL_PROVIDER.SLUG}?${queryString}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${ADMIN_API_URL.EMAIL_PROVIDER.SLUG}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getDropdownProductLov = createAsyncThunk(
  "getDropdownProductLov/get",
  async (payload, { rejectWithValue }) => {
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) =>
              value !== null && value !== undefined && value !== "",
          ),
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${API_URL.ITEM.LOOKUP}?${queryString}`;
        const { data } = await axios.get(apiUrl);
        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${API_URL.ITEM.LOOKUP}`;
        const { data } = await axios.get(apiUrl);
        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const lovSlice = createSlice({
  name: "lov",
  initialState: {
    dropdown_assignee_list: [],
    dropdown_role_list: [],
    state_list: [],
    country_list: [],
    dropdown_active_product_list: [],
    dropdown_product_group_list: [],
    dropdown_manufacturer_list: [],
    dropdown_email_provider_list: [],
    dropdown_lov_product_list: [],
  },
  reducers: {
    resetAssigneeList(state) {
      state.dropdown_assignee_list = [];
    },
    resetStateList(state) {
      state.state_list = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAssignee.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_assignee_list = data.list;
      } else {
        const combinedList = [...state.dropdown_assignee_list, ...data.list];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values(),
        );

        state.dropdown_assignee_list = uniqueList;
      }
    });
    builder.addCase(getActiveProduct.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_active_product_list = data.list;
      } else {
        const combinedList = [
          ...state.dropdown_active_product_list,
          ...data.list,
        ];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values(),
        );

        state.dropdown_active_product_list = uniqueList;
      }
    });
    builder.addCase(getProductGroupLov.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_product_group_list = data.list;
      } else {
        const combinedList = [
          ...state.dropdown_product_group_list,
          ...data.list,
        ];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values(),
        );

        state.dropdown_product_group_list = uniqueList;
      }
    });
    builder.addCase(getManufacturerLov.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_manufacturer_list = data.list;
      } else {
        const combinedList = [
          ...state.dropdown_manufacturer_list,
          ...data.list,
        ];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values(),
        );

        state.dropdown_manufacturer_list = uniqueList;
      }
    });
    builder.addCase(getAllRoles.fulfilled, (state, action) => {
      state.dropdown_role_list = action.payload.data.list;
    });
    builder.addCase(getStates.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.state_list = data.list;
      } else {
        const combinedList = [...state.state_list, ...data.list];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values(),
        );

        state.state_list = uniqueList;
      }
    });
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.country_list = action.payload.data || [];
    });
    builder.addCase(getEmailProviderLov.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_email_provider_list = data;
      } else {
        const combinedList = [...state.dropdown_email_provider_list, ...data];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values(),
        );

        state.dropdown_email_provider_list = uniqueList;
      }
    });
    builder.addCase(getDropdownProductLov.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_lov_product_list = data.list;
      } else {
        const combinedList = [...state.dropdown_lov_product_list, ...data.list];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values(),
        );

        state.dropdown_lov_product_list = uniqueList;
      }
    });
  },
});

export const { resetAssigneeList, resetStateList } = lovSlice.actions;
export default lovSlice.reducer;
